export default __webpack_public_path__ + "static/home-gary-a9179bea1313cb4e104899ba3635bce1.jpg";